<template>
  <div>
    <!--begin: mobile header -->
    <a
      href="#"
      class="hide-lg position-absolute left-0 py-2 px-5"
      style="top: 20px;"
    >
      <img src="media/logos/externalis_blue_half.png" width="80" />
    </a>
    <!--end: mobile header -->
    <!--begin::Content header-->
    <div
      class="position-absolute top-0 right-0 text-right mb-15 mb-lg-0 flex-column-auto justify-content-center py-2 px-5"
    >
      <router-link class="ml-2" :to="{ name: 'login' }">
        <div class="auth_outline_btn">Sign In</div>
      </router-link>
    </div>
    <!--end::Content header-->

    <!--begin::Signup-->
    <div class="login-form login-signin">
      <div class="text-center mb-10 pb-5">
        <div class="auth_signIn_heading pb-3">Sign up for an account</div>
      </div>

      <b-form class="form" @submit.stop.prevent="onSubmit">
        <button class="auth_socialmedia_btn mb-5" ref="kt_login_signin_submit">
          <div>
            <img
              src="media/logos/google_logo.png"
              width="20"
              class="float-left"
            />
            <span class="position-absolute right-0 left-0"
              >Sign up with Google</span
            >
          </div>
        </button>

        <button class="auth_socialmedia_btn" ref="kt_login_signin_submit">
          <div>
            <img
              src="media/logos/facebook_logo.png"
              width="20"
              class="float-left"
            />
            <span class=" position-absolute right-0" style="left:15px;"
              >Sign up with Facebook</span
            >
          </div>
        </button>
      </b-form>
      <div class="auth_note pb-10 mb-10">
        Click “Sign Up” to agree to Externalis
        <a href="" class="ln">Terms of Service</a> and acknowledge that
        Externalis <a href="" class="ln">Privacy Policy</a> applies to you.
      </div>
      <div class="text-center">
        <img src="media/logos/playstore.png" width="120" class="mr-4" />
        <img src="media/logos/apple_store.png" width="120" />
      </div>
      <!--begin::Form-->
      <!-- <b-form class="form" @submit.stop.prevent="onSubmit">
        <b-form-group
          id="example-input-group-0"
          label=""
          label-for="example-input-0"
        >
          <b-form-input
            class="form-control form-control-solid h-auto py-5 px-6"
            id="example-input-0"
            name="example-input-0"
            v-model="$v.form.username.$model"
            :state="validateState('username')"
            aria-describedby="input-0-live-feedback"
            placeholder="Username"
          ></b-form-input>

          <b-form-invalid-feedback id="input-0-live-feedback">
            Username is required.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="example-input-group-1"
          label=""
          label-for="example-input-1"
        >
          <b-form-input
            class="form-control form-control-solid h-auto py-5 px-6"
            id="example-input-1"
            name="example-input-1"
            v-model="$v.form.email.$model"
            :state="validateState('email')"
            aria-describedby="input-1-live-feedback"
            placeholder="Email address"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">
            Email is required and a valid email address.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="example-input-group-2"
          label=""
          label-for="example-input-2"
        >
          <b-form-input
            class="form-control form-control-solid h-auto py-5 px-6"
            type="password"
            id="example-input-2"
            name="example-input-2"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
            placeholder="Password"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">
            Password is required.
          </b-form-invalid-feedback>
        </b-form-group>

        <div class="form-group d-flex flex-wrap flex-center">
          <button
            type="submit"
            ref="kt_login_signup_submit"
            class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
          >
            Submit
          </button>
          <button
            v-on:click="$router.push('login')"
            class="btn btn-light-primary font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
          >
            Cancel
          </button>
        </div>
      </b-form> -->
      <!--end::Form-->
    </div>
    <!--end::Signup-->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import { REGISTER } from "@/core/store/modules/auth";
import { LOGOUT } from "@/core/store/modules/auth";

import { validationMixin } from "vuelidate";
import { email, required, minLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "register",
  data() {
    return {
      // Remove this dummy login info
      form: {
        email: "admin@demo.com",
        password: "demo"
      }
    };
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        username: null,
        email: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const username = this.$v.form.username.$model;
      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signup_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send register request
        this.$store
          .dispatch(REGISTER, {
            email: email,
            password: password,
            username: username
          })
          .then(() => this.$router.push({ name: "dashboard" }));

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 2000);
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
